import { Button, Col, Row } from "rsuite";
import { ArrowClockwise } from "react-bootstrap-icons";
import { useLocation } from "react-router-dom";
import type { HeaderProps } from "../my-type";
import { GoChevronLeft } from "react-icons/go";


export default function Header({ HeaderTitle, isShowRefresh, OnReturn, OnRefresh }: HeaderProps) {
  const location = useLocation();


  return (
    // <div style={{
    //   backgroundColor: 'black', color: 'white', height: '50px', zIndex: '99', position: 'fixed', width: '100%'
    // }}>
    <div>
      {/* <CustomNavbar activeKey={activeKey} onSelect={setActiveKey} />
      <br></br> */}

      <>
        <Row>
          {/* <Col xsHidden md={1}></Col> */}
          <Col xs={23} md={15} style={{ textAlign: 'left' }}>
            {location.pathname !== "/" && <><div onClick={OnReturn} style={{ cursor: 'default' }}>
              <GoChevronLeft style={{ fontSize: '20px' }} /> Back
            </div><br></br><br></br><h3>{HeaderTitle}</h3></>}
          </Col>
          <Col xs={1} md={8} style={{ textAlign: 'right' }}>
            {isShowRefresh && <Button appearance="link" onClick={OnRefresh} startIcon={<ArrowClockwise style={{ fontSize: '20px' }} />}>Refresh</Button>}
          </Col>
          <Col xsHidden md={1}></Col>
        </Row>

      </>


    </div >

  )


}
